module.exports = __webpack_public_path__ + "static/media/section-2-img-3.18caad19.png";